import { type ProductCategoryNavigationDesktopFragmentFragment } from '@packages/gql/generated/shopping/graphql';

// Recursive category node type
export type CategoryNode = ProductCategoryNavigationDesktopFragmentFragment & {
  children: CategoryNode[];
};

/**  A function to build a tree structure of categories */
export const buildCategoryTree = (
  flatCategories: ProductCategoryNavigationDesktopFragmentFragment[],
): CategoryNode[] => {
  const categoryById = new Map<string, CategoryNode>();
  const rootCategories: CategoryNode[] = [];

  // Create an entry for every category in the lookup
  for (const category of flatCategories) {
    categoryById.set(category.id, { ...category, children: [] });
  }

  // Link each category to its parent, or mark as root if no valid parent
  for (const category of flatCategories) {
    const categoryNode = categoryById.get(category.id);

    if (categoryNode) {
      if (
        category.parentId &&
        category.parentId !== category.id &&
        categoryById.has(category.parentId)
      ) {
        const parentCategoryNode = categoryById.get(category.parentId);
        if (parentCategoryNode) {
          parentCategoryNode.children.push(categoryNode);
        }
      } else {
        rootCategories.push(categoryNode);
      }
    }
  }

  return rootCategories;
};
